import React from 'react';
import {useSelector} from 'react-redux';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    assignGroupMemberBulk,
    getUserGroupUpdateProgress,
    stopUserGroupBulkUpdate,
} from 'src/openapi/admin/apis/BulkGroupAssignApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    GROUP_MODAL_TITLES,
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
} from '../constants';
import {
    selectUpdateUserGroupTask,
    selectUpdateUserGroupUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from '../update-user-group.slice';

import {AssignToGroupModal} from './assign-to-group.modal';

import type {UpdateUserGroup} from 'src/openapi/admin/models/UpdateUserGroup';
import type {AppState} from 'src/store/typedef';

type Props = {
    shown: boolean,
    accountIdsSelector: (state: AppState, userIds: number[]) => number[],
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const AssignToGroupTool = ({shown, accountIdsSelector, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();
    const accountIds = useSelector((state: AppState) => accountIdsSelector(state, userIds));

    return (
        <BulkActionTool<UpdateUserGroup[]>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={GROUP_MODAL_TITLES.ASSIGN}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateUserGroupTask}
            uuidSelector={selectUpdateUserGroupUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateUserGroup, options) => (
                apiDispatch(assignGroupMemberBulk({...options, updateUserGroup}))
            )}
            getProgress={id => apiDispatch(getUserGroupUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopUserGroupBulkUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <AssignToGroupModal {...{accountId: accountIds[0] || -1, userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
